// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__wcbhH","footer":"ModalUpdate_footer__3yF56"};